// src/redux/Slices/createSlices.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import handleAsyncThunk from "../handleAsyncThunk.js";
import sessionApi from "../../services/sessionApi.js";
import { storage } from "../../config/storage";

export const session = createAsyncThunk("auth/session", async () => {
    const key = storage.fetchFromSessionStorage.sessionKey()
    // Check if key exists in session-storage already or not
    if(key) {
        return {
            sessionKey: key
        }
    }else {
        const response = await sessionApi.requestCreateSession();    
        storage.setInSessionStorage.sessionKey(response?.data?.sessionKey);
        return response?.data;
    }
});


const sessionSlice = createSlice({
    name: "session",
    initialState: {
        isSession: false,
    },

    extraReducers: (builder) => {
        handleAsyncThunk(builder, session, "session"); // Use builder notation
    },
});

export const { setIsSession } = sessionSlice.actions;


export default sessionSlice.reducer